import { render } from "./GrayActionButton.vue?vue&type=template&id=3a664386&scoped=true"
import script from "./GrayActionButton.vue?vue&type=script&lang=js"
export * from "./GrayActionButton.vue?vue&type=script&lang=js"

import "./GrayActionButton.vue?vue&type=style&index=0&id=3a664386&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a664386"]])

export default __exports__